import { Mail, MapPin, Shield, Calendar } from "lucide-react";

const ContactUs = () => {
  return (
    <section>
      <div className="container flex flex-col lg:max-w-4xl w-full px-5 py-12 md:py-24 mx-auto">
        <div className="w-full">
          <h1 className="text-4xl text-gray-800 dark:text-white font-bold title-font mb-6">
            Contact us
          </h1>
          <p className="leading-relaxed text-xl text-gray-600 dark:text-gray-300 mb-8">
            Looking to enhance your security, have questions, or need expert
            advice? Contact our team for a free consultation and see how we can
            support your business.
          </p>

          {/* Free Cyber Assessment CTA */}
          <div className="bg-gradient-to-r from-green-50 to-blue-50 dark:from-green-900/20 dark:to-blue-900/20 border border-green-200 dark:border-green-700 rounded-lg p-6 mb-8">
            <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-3 flex items-center">
              <Shield className="text-green-600 mr-2" size={24} />
              Claim Your Free Expert-Led Cyber Assessment (30 mins)
            </h2>
            <p className="text-gray-700 dark:text-gray-300 mb-4">
              Our Cybersecurity experts will identify cyber risks and provide
              tailored recommendations for your business.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="mailto:contact@hackdefense.org"
                className="inline-flex items-center justify-center px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg transition-colors duration-200"
              >
                <Mail className="mr-2" size={20} />
                Reach Out for Assessment
              </a>
              <button
                onClick={() => {
                  // This will open Calendly in a popup - replace with your actual Calendly URL
                  window.open(
                    "https://calendly.com/contact-hackdefense/30min",
                    "calendly",
                    "width=800,height=600"
                  );
                }}
                className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition-colors duration-200"
              >
                <Calendar className="mr-2" size={20} />
                Schedule Session
              </button>
            </div>
          </div>

          {/* Contact Information */}
          <div className="bg-gray-50 bg-transparent rounded-lg p-6">
            <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-4">
              Get in Touch
            </h2>
            <div className="text-lg text-gray-700 dark:text-gray-300 space-y-4">
              <p className="flex items-center">
                <Mail className="text-green-600 mr-2" size={20} />
                Email:{" "}
                <a
                  href="mailto:contact@hackdefense.org"
                  className="text-green-500 hover:underline ml-2"
                >
                  contact@hackdefense.org
                </a>
              </p>
              {/* <p className="flex items-center">
                <Phone className="text-green-600 mr-2" size={20} />
                Phone:
                <a
                  href="tel:+447937543671"
                  className="text-green-500 hover:underline ml-2"
                >
                  +44 7937 54367
                </a>
              </p> */}
              <p className="flex items-center">
                <MapPin className="text-green-600 mr-2" size={20} />
                Address:
                <a
                  href="https://www.google.com/maps/place/Your+Address"
                  className="text-green-500 hover:underline ml-2"
                >
                  20 Wenlock Road, London,
                  <br />
                  N1 7GU, United Kingdom
                </a>
              </p>
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-4">
                We typically respond within 24 hours. 
                {/* For urgent security
                matters, please call directly. */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;
